import { createContext, useContext, useEffect, useId } from "react";

export const UnsavedChangesContext = createContext<{
  setDirty: (id: string, dirty: boolean) => void;
  requestDiscard: (action: () => void) => void;
}>({
  setDirty: () => undefined,
  requestDiscard: (action: () => void) => action(),
});

/** Register a form without coupling its fields to routing or storage. */
export function useUnsavedChanges(dirty: boolean) {
  const id = useId();
  const { setDirty, requestDiscard } = useContext(UnsavedChangesContext);
  useEffect(() => {
    setDirty(id, dirty);
    return () => setDirty(id, false);
  }, [id, dirty, setDirty]);
  return requestDiscard;
}

export function useConfirmDiscard() {
  return useContext(UnsavedChangesContext).requestDiscard;
}
